import { eur } from "../../lib/constants";

export const COST_TYPES = [["trasporto", "Trasporto e spedizione"], ["imballaggio", "Imballaggio"], ["altro", "Spesa aggiuntiva"]];
export const BASES = [["ordine", "Fisso per ordine"], ["articolo", "Per singolo articolo"], ["percentuale", "% sul valore dell'ordine"], ["unita", "Per unità di misura"], ["personalizzato", "Condizione personalizzata"]];
export const DOC_CATS = [["listino", "Listino"], ["condizioni", "Condizioni commerciali"], ["altro", "Altro documento"]];
export const label = (list, v) => (list.find((x) => x[0] === v) || [v, v])[1];

const pct = (n) => `${Number(n).toLocaleString("it-IT", { maximumFractionDigits: 2 })}%`;
export const discountSteps = (d) => [...(d.discount_pct != null ? [d.discount_pct] : []), ...(d.cascade || [])];
export const discountText = (d) => {
  const s = discountSteps(d);
  if (!s.length) return d.discount_amount != null ? eur(d.discount_amount) : "—";
  return s.map((p) => Number(p).toLocaleString("it-IT", { maximumFractionDigits: 2 })).join(" + ") + "%";
};
export const effectivePct = (d) => {
  const f = discountSteps(d).reduce((a, p) => a * (1 - p / 100), 1);
  return pct((1 - f) * 100);
};
export const costText = (c) => {
  const a = c.amount;
  const base = c.basis === "percentuale" ? `${pct(a)} del netto`
    : c.basis === "articolo" ? `${eur(a)} per articolo`
    : c.basis === "unita" ? `${eur(a)} per ${c.unit || "unità"}`
    : c.basis === "personalizzato" ? (a != null ? `circa ${eur(a)} · da valutare` : "da valutare caso per caso")
    : `${eur(a)} per ordine`;
  return c.free_over != null ? `${base} · gratuito oltre ${eur(c.free_over)}` : base;
};
export const today = () => new Date().toLocaleDateString("sv-SE");
